export default __webpack_public_path__ + "static/media/water_logo.4f1ec565.svg";